import axios from 'config/api';
import {
  ADD_TEMPLATE_ERROR,
  ADD_TEMPLATE_SUCCESS,
  FETCH_TEMPLATES_SUCCESS,
  UPDATE_TEMPLATE_SUCCESS,
  FETCH_CLIPPINGS_SUCCESS,
} from 'config/constants';

function addTemplate(template) {
  return axios
    .post(`/admin/templates`, template)
    .then(response => {
      const { data, status } = response;
      if (status === 200) {
        return {
          type: ADD_TEMPLATE_SUCCESS,
          template: data,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: ADD_TEMPLATE_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

function fillTemplate(id) {
  return axios.get(`admin/templates/${id}`).then(({ data }) => {
    return {
      type: FETCH_TEMPLATES_SUCCESS,
      data: data,
    };
  });
}

function updateTemplate(id, template) {
  return axios.put(`/admin/templates/${id}`, template).then(({ data }) => {
    return {
      type: UPDATE_TEMPLATE_SUCCESS,
      data: data,
    };
  });
}

export default {
  addTemplate,
  fillTemplate,
  updateTemplate,
};
